module.exports = __webpack_public_path__ + "img/30.3a4f9e71.jpg";